<div class="add-container">
  <h4>Which type of purchase order do<br> you want to create?</h4>
  <mat-radio-group aria-labelledby="example-radio-group-label"
    class="example-radio-group bidone-radio"
    [(ngModel)]="addPurchaseOrderObject.selectedType"
    (ngModelChange)="selectedTypeChange()">
    @for (t of typeList; track t) {
      <mat-radio-button class="example-radio-button"
        [value]="t.value"
        [name]="t.label">
        {{ t?.label }}
      </mat-radio-button>
    }
  </mat-radio-group>
</div>

<!-- Job Selection - Only show when type is Regular or Bulk -->
@if (addPurchaseOrderObject.selectedType !== 'vendor') {
  <div class="inline-container">
    <label for="job_id" class="mt-4">Job Name</label>
    <div class="form-row">
      <div class="form-group col-12">
        <ng-select
          [items]="jobList"
          bindLabel="name"
          bindValue="id"
          [searchable]="true"
          [closeOnSelect]="addPurchaseOrderObject.selectedType === 'regular'"
          [typeahead]="jobInput$"
          [multiple]="addPurchaseOrderObject.selectedType === 'bulk'"
          [clearable]="true"
          [loading]="isJobLoading"
          [(ngModel)]="addPurchaseOrderObject.jobId"
          (change)="selectedValueChange($event, addPurchaseOrderObject.selectedType)"
          >
          <!-- CUSTOM LABEL FOR SELECTED ITEMS -->
          <ng-template ng-label-tmp let-item="item" let-clear="clear">
            @if (addPurchaseOrderObject.selectedType === 'bulk') {
              <div class="d-flex justify-content-between align-items-center">
                <div>
                  {{ item.job_number }}  {{ item.name }}
                </div>
                <span class="ng-value-icon right" (click)="removeSelected(item, clear)">×</span>
              </div>
            } @else {
              <div class="d-flex justify-content-between align-items-center w-100">
                <div>
                  {{ item.job_number }} {{ item.name }} ({{ item.company_name }})
                </div>
                @if (item?.jobvalue) {
                  <div class="label-right">
                    <span class="text">{{ item?.jobvalue | currency }}</span>
                  </div>
                }
              </div>
            }
          </ng-template>
          <!-- CUSTOM DROPDOWN OPTION -->
          <ng-template ng-option-tmp let-item="item">
            <div class="d-flex justify-content-between align-items-center w-100">
              <div>
                {{ item.job_number }} {{ item.name }}
                ({{ item.company_name }})
              </div>
              @if (item?.jobvalue) {
                <div class="label-right">
                  <span class="text">{{ item?.jobvalue | currency }}</span>
                </div>
              }
            </div>
          </ng-template>
        </ng-select>
        <app-validation-error [formGroup]="jobNameFormGroup" [controlName]="'job_name'"></app-validation-error>
      </div>
    </div>
  </div>
}

<!-- Vendor Selection - Only show when type is Vendor -->
@if (addPurchaseOrderObject.selectedType === 'vendor') {
  <div class="inline-container">
    <label for="vendor_id" class="mt-4">Vendor Name</label>
    <div class="form-row">
      <div class="form-group col-12">
        <ng-select
          [items]="vendorList"
          bindLabel="name"
          bindValue="id"
          [searchable]="true"
          [closeOnSelect]="true"
          [typeahead]="vendorInput$"
          [multiple]="false"
          [clearable]="true"
          [loading]="isVendorLoading"
          [(ngModel)]="addPurchaseOrderObject.vendorId"
          (change)="onVendorSelected($event)"
          >
          <!-- CUSTOM LABEL FOR SELECTED VENDOR -->
          <ng-template ng-label-tmp let-item="item" let-clear="clear">
            <div class="d-flex justify-content-between align-items-center w-100">
              <div>
                {{ item.name }}
              </div>
              <span class="ng-value-icon right" (click)="removeVendorSelected(clear)">×</span>
            </div>
          </ng-template>
          <!-- CUSTOM DROPDOWN OPTION -->
          <ng-template ng-option-tmp let-item="item">
            <div class="d-flex justify-content-between align-items-center w-100">
              <div>
                {{ item.name }}
              </div>
            </div>
          </ng-template>
        </ng-select>
      </div>
    </div>
  </div>
}
